import { Component, inject, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HelpersService } from 'src/app/services/helpers.service';
import { DefaultService } from 'src/app/utils/api';

@Component({
    selector: 'app-add-api-key',
    standalone: false,
    templateUrl: './add-api-key.component.html',
    styleUrl: './add-api-key.component.scss'
})
export class AddApiKeyComponent {
    router = inject(Router);
    route = inject(ActivatedRoute);
    defaultService = inject(DefaultService);
    toastr = inject(ToastrService);
    helperService = inject(HelpersService);

    changes = false;
    submitting = false;

    apiKey: string = '';
    FORM: string = '';
    validation: any = {};

    submitted = output<void>();

    generateApiKey() {
        this.submitting = true;
        this.defaultService.apikeysCreateApiKey({ klant: this.FORM }).subscribe({
            next: (next) => {
                this.submitting = false;
                this.changes = false;
                this.apiKey = next.key;
                this.submitted.emit();
                this.toastr.success('Api key werd succesvol geneneerd.', 'Api key gegenereerd');
            },
            error: (error) => {
                this.submitting = false;
                this.apiKey = '';
                this.validation = error.error.details;
            }
        });
    }

    copyToClipboard() {
        this.helperService.copyToClipboard(this.FORM, 'Gekopieerd naar klembord');
    }

    formChange() {
        this.changes = true;
    }

    dismiss() {
        if (this.canExit()) {
            this.submitted.emit();
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }
    canExit(): boolean {
        if (
            (!this.changes && !this.submitting) ||
            confirm('You have unsaved changes, are you sure you want to leave?')
        ) {
            this.changes = false;
            return true;
        } else {
            return false;
        }
    }
}
